import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";

// Redux
import { saveSubcategory, GetSubcategory } from "./index";

// Api's
import { subcategoryApi } from "../../api";
import { CategoryResponse } from "@/main/models/response";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getSubcategorySaga(action: GetSubcategory) {
	try {
		const response: AxiosResponse<Result<CategoryResponse[]>> = yield call(
			subcategoryApi.getDomain,
			action.payload.request,
		);

		if (response.data.result) {
			yield put(saveSubcategory(response.data.result, false, null, action.payload.keyReducer));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveSubcategory(null, true, resultError.messagesDataError, action.payload.keyReducer));
		}
	}
}
